module.exports = __webpack_public_path__ + "img/pinterest.b53a7131.svg";